import React from "react"
// import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Layout, SEO, Hero, About, Jobs, Projects, Contact } from "@containers"

const MainContainer = styled.main`
  counter-reset: section;
`

const IndexPage = ({ location }) => (
  <>
    <SEO title="Anubhav Kumar" />
    <Layout location={location}>
      <MainContainer>
        <Hero />
        <About />
        <Jobs />
        <Projects />
        <Contact />
      </MainContainer>
    </Layout>
  </>
)

IndexPage.propTypes = {
  location: PropTypes.oneOfType([PropTypes.object]).isRequired,
}

export default IndexPage
